<div class="errorPage">
    <div id="pageerror" class="container">
        <div class="notfound">
            <svg>
                <use xlink:href="#app-icon-not-support"></use>
            </svg>
        </div>
        <div class="headtext">
            <h1>404 Not Found</h1>
        </div>
        <div class="spantext">
            {{i18n.get | fn :'common.404_NotFound_info_label'}}
        </div>
    </div>
</div>
